module.exports = __webpack_public_path__ + "src/assets/img/autorambler.5ea0988a.jpg";